import { Card, Row } from 'antd';
import React from 'react'
import Heading from '../../../../component/common/Heading';
import CRUDComponent from '../../../../component/common/CRUD-Component';
import CONSTANTS from '../../../../util/constant/CONSTANTS';
import { PERMISSION } from '../../../../util/functions';
import { faqExportData } from '../../../../util/exportData';

const FAQ = ({ accessPermission }) => {
    return (
        <>
            <div>
                <Card className="my-5">
                    <Heading>FAQ</Heading>
                    <Row>
                        <CRUDComponent
                            title='FAQ'
                            exportData={faqExportData}
                            accessPermission={accessPermission}
                            GET={{
                                API: CONSTANTS.API.setting.faq.getAll,
                                extraQuery: {sortBy: "DESC"},
                                DataModifier: (res, API, Setrefresh) => {
                                    return res?.map(data => {
                                        return {
                                            ...data,
                                            no: `T${data?.id.toString().padStart(7, "0")}`,
                                            rating: {
                                                ratings: data?.starRating ?? 0
                                            },
                                            rankingNumber: data?.ranking,
                                            ranking: {
                                                data: data?.ranking,
                                                onBlur: (Rank) => {
                                                    if (!isNaN(Number(Rank))) {
                                                        const UpdateAPIEnd = { ...CONSTANTS.API.setting.faq.update };
                                                        UpdateAPIEnd.endpoint = `${UpdateAPIEnd?.endpoint}${data?.id}`;
                                                        API.sendRequest(
                                                            UpdateAPIEnd,
                                                            () => {
                                                                Setrefresh((prev) => !prev);
                                                            },
                                                            { ranking: Number(Rank) },
                                                            `Ranking Update Successfully`
                                                        );
                                                    }
                                                }
                                            },
                                            isBlockedD: data?.isBlocked ? 'Yes' : 'No',
                                            toggle: {
                                                checked: !data?.isBlocked,
                                                id: data?.id,
                                                isDisable: PERMISSION[accessPermission] === 'READ',
                                                onClick: (id, val) => {
                                                    const UpdateAPIEnd = { ...CONSTANTS?.API.setting.faq.update };
                                                    UpdateAPIEnd.endpoint = `${UpdateAPIEnd?.endpoint}${id}`;
                                                    API.sendRequest(
                                                        UpdateAPIEnd,
                                                        () => {
                                                            Setrefresh((prev) => !prev);
                                                        },
                                                        { isBlocked: val },
                                                        `FAQ ${val ? "Blocked" : "Unblock"} Successfully`
                                                    );
                                                },

                                            },


                                        }
                                    });
                                },
                                column: CONSTANTS.TABLE.FAQ,
                            }}
                            isSearch
                            UPDATE={{
                                API: CONSTANTS.API.setting.faq.update,
                                message: "Edit FAQ successfully",
                                modaltitle: "Edit FAQ",
                                modalFields: CONSTANTS.FORM_FIELD.FAQ_MODAL,
                                // payloadModifier: (res) => res,
                            }}
                            CREATE={{
                                API: CONSTANTS.API.setting.faq.add,
                                message: "Created FAQ successfully",
                                modaltitle: "Add FAQ",
                                modalFields: CONSTANTS.FORM_FIELD.FAQ_MODAL,
                                // payloadModifier: (res) => res,
                            }}
                            DELETE={{
                                API: CONSTANTS.API.setting.faq.delete,
                                message: "Deleted FAQ Successfully",
                            }}
                        />
                    </Row>
                </Card>

            </div>
        </>
    )
}

export default FAQ